module.exports = __webpack_public_path__ + "img/aboutUs6_en.bcf775c.png";